const orderBase = {
  uuid: null,
  sandbox: false,
  orderType: 0,
  personnelUUID: null,
  consumerUUID: null,
  insertDeviceUUID: null,
  insertDeviceType: null,
  insertUserUUID: null,
  orderNumber: null,
  orderIdentifier: '',
  notes: '',
  currency: 'huf',
  locationUUID: null,
  languageCode: 'hu',
  invoiceNeeded: 0,
  invoiceInfo: null,
  deliveryInfo: null,
  deliveryType: null,
  deliveryCost: 0,
  paymentType: null,
  requestedReadyTime: null,
  takeAway: null,
  tableUUID: null,
  groupUUID: null,
  vipID: null,
  price: 0,
  insertTimestamp: null,
  payments: [],
  externalPayments: [],
  statuses: [],
  items: [],
  invoices: [],
  discounts: [],
  itemDiscounts: [],
  serviceFee: null,
  tipAmount: 0,
  tippType: 0,
  sysUserUUID: null,
  depositPrice: 0,
}

const orderItemBase = {
  orderItemUUID: null,
  parentOrderItemUUID: null,
  count: 0,
  quantity: null,
  price: 0,
  vat: 0,
  itemUUID: '',
  categoryUUID: '',
  takeAway: null,
  selectedSizeUUID: null,
  modifiers: [],
  notes: '',
  servingID: null,
  insertTimestamp: null,
  sysUserUUID: null,
  deviceUUID: null,
  updateUID: null,
  depositPrice: 0,
  depositVat: 0,
  depositType: null
}

const orderItemModifierBase = {
  orderModifierUUID: null,
  modifierUUID: null,
  modifierGroupUUID: null,
  count: 0,
  price: 0
}

export { orderBase, orderItemBase, orderItemModifierBase }
